// Single source of truth for the admin session tokens.
// access  -> in memory only (never persisted): smallest XSS window, dies on reload.
// refresh -> sessionStorage (tab lifetime): rotated on every refresh; matches the
//            existing posture of keeping admin credentials out of localStorage.
const REFRESH_KEY = 'nd_admin_refresh';

let accessToken: string | null = null;
const listeners = new Set<() => void>();

function emit(): void {
  listeners.forEach((cb) => cb());
}

export function getAccess(): string | null {
  return accessToken;
}

export function getRefresh(): string | null {
  try {
    return sessionStorage.getItem(REFRESH_KEY);
  } catch {
    return null; // storage blocked (private mode) -> in-memory session only
  }
}

export function setTokens(t: { access: string; refresh: string }): void {
  accessToken = t.access;
  try {
    sessionStorage.setItem(REFRESH_KEY, t.refresh);
  } catch {
    // storage unavailable: keep access in memory, session lost on reload
  }
  emit();
}

export function clear(): void {
  accessToken = null;
  try {
    sessionStorage.removeItem(REFRESH_KEY);
  } catch {
    // ignore
  }
  emit();
}

export function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}
